import { render, staticRenderFns } from "./KorrekturbuchungsModal.vue?vue&type=template&id=d19485c6&"
import script from "./KorrekturbuchungsModal.vue?vue&type=script&lang=js&"
export * from "./KorrekturbuchungsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports